export default __webpack_public_path__ + "static/media/1412.03b12358.png";